export default __webpack_public_path__ + "assets/images/region-activity-map.png";